import React, { useEffect, useState } from "react";
import {  Container } from "reactstrap";
import Button from "@mui/material/Button";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Action, DefaultPerPageValue, PerPage, ProjectTag } from "../../constants/Common";
import {
  changeRequestStatusUpdate,
  getAllChangeRequest,
} from "../../api/casp/changeRequest";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import DescriptionIcon from "@mui/icons-material/Description";
import { ChangeRequestStatus } from "../../constants/Status";
import { Modules } from "../../constants/Module";
import ShowCommentModal from "../../Components/casp/common/ShowCommentModal";
import { ChangeRequestStatusColor } from "../../constants/ChangeRequestStatus";
import { useSelector } from "react-redux";
import { Role } from "../../constants/Role";
import IconButton from "@mui/material/IconButton";
import EditIcon from "../../assets/images/icons/edit-line.svg";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import { getIconPath } from "../../helpers/file_helper";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { hasModulePermission } from "../../helpers/permission";
import { withTranslation } from "react-i18next";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { PaginationComponent } from "../../Components/casp/common/PaginationComponent";
import UserProfile from "../../Components/casp/common/userProfile";

const ChangeRequestList = (props) =>{
  const [page, setPage] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [allChangeRequest, setAllChangeRequest] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState();
  const loggedInUser = useSelector((state) => state.Profile.user);
  const hasCRCreatePermission = hasModulePermission(Modules.CHANGE_REQUEST, Action.CREATE)
  const { project } = useParams()
  const [paginationObject, setPaginationObject] = useState({});
  const [mounted, setMounted] = useState(false);
  const [triggerElement, setTriggerElement] = useState(+new Date())

  useEffect(() => {
    if (mounted) {
      setTriggerElement(+new Date())
    }
  }, [page])

  useEffect(() => {
    fetchChangeRequestList({ page: page + 1, perPage: rowsPerPage });
    if (!mounted) {
      setMounted((true))
    }
  }, [triggerElement]);

  useEffect(() => {
    if (mounted) {
        if (page !== 0) {
            setPage(0)
            setTriggerElement(+new Date())
        } else {
            setTriggerElement(+new Date())
        }
    }
  }, [rowsPerPage])


  // Pagination Operation
  const handleChangePage = async (event, newPage) => {
    setAllChangeRequest([])
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
      setAllChangeRequest([])
      const perPage = parseInt(event.target.value);
      setRowsPerPage(perPage);
  };

  const fetchChangeRequestList = async (params = { page: 0, perPage: rowsPerPage }) => {
    try {
      setIsLoading(true);
      let tempParams = {
        projectIds: [parseInt(project)],
        ...params
      };
      if(props.projectId){
        tempParams.projectIds = [props.projectId]
      }
      const res = (await getAllChangeRequest(tempParams)).data.data;
      let inc = (page + 1 - 1) * rowsPerPage;
      if (res.data.length > 0) {
        setAllChangeRequest(
          res.data.map((changeRequest) => ({
            indexNo: ++inc,
            uniqueChangeRequestId: changeRequest.uniqueChangeRequestId,
            sections: [
              ...new Set(
                changeRequest.changeRequestItems.map((item) => item.sections)
              ),
            ].join(", "),
            id: changeRequest.id,
            date: dayjs(changeRequest.createdAt).format("DD.MM.YYYY"),
            impact: changeRequest.impact,
            status: changeRequest.status ,
            projectId: changeRequest.projectId,
            projectTag: changeRequest.project.tag,
            project: changeRequest.project.name,
            previousApproval: changeRequest.previousApproval,
            creator: changeRequest.creator,
            currentApproval:{
              user: changeRequest.latestApproval?.currentApprovalUser?.user,
              role:changeRequest.latestApproval?.currentApprovalUser?.user?.projectUsers[0]?.role,
            }
          }))
        );
        setTotalRows(res.meta.total);
        setPaginationObject(res.meta)
      } else {
        setAllChangeRequest([]);
        setTotalRows(0);
        setPage(0);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaginationModelChange = (data) => {
    setPage(data.page);

    if (rowsPerPage !== data.pageSize) {
      setRowsPerPage(data.pageSize);
    }
  };

  const getRowId = (row) => row.id;

  const columns = [
    {
      field: "indexNo",
      headerName: "#",
      width: 45,
      filterable: false,
      sortable: false,
    },
    {
      field: "uniqueChangeRequestId",
      headerName: props.t("Change Request ID"),
      width: 200,
      filterable: false,
      sortable: false,
    },
    {
      field: "project",
      headerName: props.t("Project"),
      width: 120,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div className={`text-capitalize text-truncate`} title={params.value}>{params.value}</div>
      ),
    },
    {
      field: "date",
      headerName: props.t("Date"),
      width: 120,
      filterable: false,
      sortable: false,
    },
    {
      field: "sections",
      headerName: props.t("Sections"),
      width: 250,
      filterable: false,
      sortable: false,
    },
    {
      field: "impact",
      headerName: props.t("Impact"),
      width: 240,
      filterable: false,
      sortable: false,
    },
    {
      field: "status",
      headerName: props.t("Status"),
      width: 150,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <>
        <div className={`statusBadge small_status_chip ${ChangeRequestStatusColor(params.value)} badge-outlined text-capitalize`}>
          {params.value === ChangeRequestStatus.IN_APPROVAL ? props.t("pending") : props.t(params.value)}
        </div>
          {params.value === ChangeRequestStatus.REJECTED && (
            <DescriptionIcon
              className="redTxt cursor-pointer"
              onClick={() =>
                handleOpen(
                  params?.row.previousApproval?.comments,
                  params?.row.previousApproval?.currentApprovalUser?.user
                )
              }
            />
          )}
          </>
      ),
    },
    {
      field: "currentApprovalUser",
      headerName: props.t("Current Approval User"),
      headerClassName: "super-app-theme--header",
      width: 240,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
          {params.row?.currentApproval.user ?
            <>
            <UserProfile user={params.row?.currentApproval.user} profileStyle ={{height: '23px', width: '23px', fontSize: '15px'}} />
            <div className="MuiDataGrid-cellContent">
                <span className="m-2 text-truncate" title={(params.row?.currentApproval.role?.name)}>
                  {params.row?.currentApproval.user?.name}
                </span>
            </div>
            </> :
            'N/A'
          }
        </div>
    ),
    },
    {
      field: "actions",
      headerName: props.t("Actions"),
      width: 180,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => {
        const showSubmit = params.row.status === ChangeRequestStatus.DRAFT || params.row.status === ChangeRequestStatus.REJECTED;
        return (
          <div className="taskTbActions">
            <RemoveRedEyeOutlinedIcon
              style={{ cursor: !props?.disabled ? 'pointer' : 'not-allowed' }}
              onClick={() => {
                navigate(`/project/${params.row.projectId}/change-request/${params.row?.id}/details`);
              }}
            />
            {showSubmit && loggedInUser.id === params.row?.creator?.id && (
              <>
                {/* <IconButton 
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate(`/project/${params.row.projectId}/change-request/${params.row?.id}/update`);
              }}
              >
              <img src={EditIcon} alt={EditIcon} />
            </IconButton> */}
                <EditOutlinedIcon 
                  style={{ cursor: (!props?.disabled && params.row?.projectTag === ProjectTag.ACTIVE) ? 'pointer' : 'not-allowed' }}
              className="mx-3" onClick={() => {
                  navigate(`/project/${params.row.projectId}/change-request/${params.row?.id}/update`);
                }} />

                <Button
                  onClick={() => submitChangeRequest(params.row)}
                  style={{ cursor: (!props?.disabled && params.row?.projectTag === ProjectTag.ACTIVE) ? 'pointer' : 'not-allowed' }}
                  //className="edit_button mx-2"
                  className="w-50 main-login-btn main_btn_small btn btn-secondary align-items-center btn btn-secondary btn btn-secondary"
                  variant="contained"
                >
                  {props.t('Submit')}
                </Button>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const submitChangeRequest = async (object) => {
    const res = await changeRequestStatusUpdate(object.id, {
      projectId: object.projectId,
    });
    if (res.statusCode === 200) {
      setTotalRows(0);
      setPage(0);
      fetchChangeRequestList();
    }
  };

  const handleOpen = (comment, data) => {
    setOpen(true);
    setRejectReason({
      name: data?.name,
      profilePicture: data?.profilePicture,
      role:data?.projectUsers[0]?.role?.name ?? '',
      comment,
    });
  };

  const handleRejectModal = () => {
    setOpen(!open);
    setRejectReason()
  };
  return (
    <React.Fragment>
      <div className={`position-relative ${!props.projectId ? 'page-content' : 'mainPageHeader' }`}>
      <Helmet
                onChangeClientState={(newState, addedTags) => {
                  try {
                  // Check if we added any new link[rel="icon"] elements.
                  const newFaviconElems = filter(get(newState, 'linkTags', []), {
                      rel: 'icon',
                  })

                  if (!newFaviconElems.length) {
                      return
                  }

                  // Get the href of the last link element we just added, which
                  // we assume is the most recently-added favicon.
                  const newFaviconHref =
                      newFaviconElems[newFaviconElems.length - 1].href

                  // Remove all react-helmet link elements with rel="icon" that
                  // do not have the href of our recently-added favicon.
                  // If no other favicon elements exist, we don't have to do
                  // anything.
                  const existingFavicons = document.querySelectorAll(
                      `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
                  )

                  if (existingFavicons.length) {
                      existingFavicons.forEach(e => e.parentNode.removeChild(e))
                  }

                  // Remove and re-add the latest link element to make sure
                  // the browser uses it.
                  const newFaviconElem = document.querySelector(
                      `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
                  )

                  if (newFaviconElem) {
                      const newFavElement = newFaviconElem.cloneNode(true)
                      newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                          `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<PublishedWithChangesIcon />)}</svg>`
                        )}`
                      const parentElem = newFaviconElem.parentNode
                      parentElem.removeChild(newFaviconElem)
                      parentElem.appendChild(newFavElement)
                  }
                  } catch (e) {
                  console.error(e)
                  }
              }}
      >
            <title>{props.t('Change Request List')}</title>
      </Helmet>
        <Container fluid>
          <div className=" d-flex justify-content-between">
            <BreadCrumb title={props.t(props.module)} />
            {hasCRCreatePermission && !props?.disabled && allChangeRequest?.length > 0 && allChangeRequest[0].projectTag === ProjectTag.ACTIVE &&
              <Button
              className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30"
                onClick={() => navigate(`/project/${project}/create-change-request`)}
                startIcon={<AddOutlinedIcon />}
              >
                 {props.t('Add Request')}
              </Button>
            }
          </div>
          <div className="projectTypeTable my-4">
            <DataGrid
              rows={allChangeRequest}
              style={{ height: "500px",border: 'none' }}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { pageSize: rowsPerPage },
                },
              }}
              pageSizeOptions={PerPage}
              disableRowSelectionOnClick
              onPaginationModelChange={handlePaginationModelChange}
              paginationMode="server"
              rowCount={totalRows}
              getRowId={getRowId}
              loading={isLoading}
              sortingMode="server"
              hideFooter={true}
            />
            {allChangeRequest.length > 0 && (
              <div className="ongoingProjPagination d-flex justify-content-end mt-3 newRoundedPagination">
                <PaginationComponent
                  paginationObject={paginationObject}
                  page={page}
                  handleChangePage={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </div>
            )}
          </div>
        </Container>
      </div>
      <div className="rejectModal">
        <ShowCommentModal
            handleRejectModal={handleRejectModal}
            open={open}
            module={Modules.CHANGE_REQUEST}
            data={rejectReason}
        />
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(ChangeRequestList);

